<template>
  <div>
    <p>Halaman yang anda tuju tidak tersedia !!!</p>
    <p><v-btn :to="to">Kembali ke Home</v-btn></p>
  </div>
</template>

<script>
export default {
  computed: {
    to: function() {
      if (this.$store.getters.isAuthenticated) {
        return this.$store.getters.userHome
      }
      else {
        return '/'
      }
    }
  }
}
</script>

<style>

</style>